<template>
  <BaseChip
    class="base-linked-tender"
    :class="{ 'is-small': isSmall }"
    size="sm"
    tone="neutral"
    preset="soft"
    v-tooltip="{
      content: $t('page.opportunities.view-tender'),
      placement: 'top',
    }"
    @click.stop="openTenderDetails(tenderId)"
  >
    <template #leading>
      <PlatformIcon :platform="source" />
    </template>
    <template v-if="referenceNumber && onlyShowRefNumber">
      {{ $t('tender-details.reference-num', { number: referenceNumber }) }}
    </template>
    <template v-else>
      <span v-if="title" v-html="title"></span>
      <span v-if="referenceNumber && !onlyShowRefNumber">
        {{ $t('tender-details.reference-num', { number: referenceNumber }) }}
      </span>
    </template>
  </BaseChip>
</template>

<script>
import BaseChip from '@/components/base/BaseChip.vue';
import PlatformIcon from '@/components/PlatformIcon.vue';

export default {
  name: 'BaseLinkedTender',
  components: {
    BaseChip,
    PlatformIcon,
  },
  props: {
    tenderId: {
      type: String,
      required: true,
    },
    source: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    referenceNumber: {
      type: String,
      required: false,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
    onlyShowRefNumber: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openTenderDetails(tenderId) {
      this.$router.push({ name: 'tender-details', params: { id: tenderId } });
    },
  },
};
</script>

<style lang="scss">
.base-linked-tender.is-small {
  max-width: 115px;
}
</style>
